import React, { useState } from "react";
import {
  Button,
  ButtonContainer,
  ButtonIcon,
  VacancyCard,
} from "./AdminStyles";
import { smartAPI } from "../../components/api/Smart";
import {
  faCheck,
  faClipboard,
  faFileAlt,
  faTrash,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Applicants = ({ applications, setApplications }) => {
  const [message, setMessage] = useState("");

  // Delete handler
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Weet je zeker dat je deze sollicitatie wilt verwijderen?"
    );

    if (!isConfirmed) return;

    try {
      const response = await smartAPI({}, "DELETE", `apply/${id}`);
      if (response.status === 204) {
        setMessage("Sollicitatie succesvol verwijderd!");
        setTimeout(() => setMessage(""), 3000);
        fetchApplications();
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  async function fetchApplications() {
    try {
      const response = await smartAPI({}, "GET", "apply");
      if (response.status === 200) {
        setApplications(response.data);
      } else {
        setMessage("Er is iets misgegaan, probeer het opnieuw.");
      }
    } catch (error) {
      setMessage("Fout bij het verzenden, probeer later opnieuw.");
    }
  }

  return (
    <>
      {message && (
        <p
          style={{
            color: "white",
            fontWeight: "bold",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            backgroundColor: "#17224d",
            borderRadius: "5px",
            padding: "10px",
            border: "1px solid black",
          }}
        >
          <FontAwesomeIcon
            icon={faCheck}
            style={{ color: "green", marginRight: "10px" }}
          />
          {message}
        </p>
      )}
      <div
        className="vacancy-row"
        style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
      >
        {applications.map((application) => (
          <VacancyCard key={application.id}>
            <div>
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
              <strong>Voornaam:</strong> {application.first_name}
            </div>
            <div>
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} />
              <strong>Achternaam:</strong> {application.last_name}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faClipboard}
                style={{ marginRight: "8px" }}
              />
              <strong>Email:</strong> {application.email}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faClipboard}
                style={{ marginRight: "8px" }}
              />
              <strong>Motivatie:</strong> {application.motivation}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faFileAlt}
                style={{ marginRight: "8px" }}
              />
              <strong>CV:</strong> {application.cv_file}
            </div>
            <ButtonContainer>
              <Button
                style={{
                  backgroundColor: "oklch(0.637 0.237 25.331)",
                  width: "100%",
                  marginTop: "20px",
                }}
                onClick={() => handleDelete(application.id)}
              >
                <ButtonIcon icon={faTrash} /> Verwijderen
              </Button>
            </ButtonContainer>
          </VacancyCard>
        ))}
      </div>
    </>
  );
};

export default Applicants;
